import * as React from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { useStaticContext } from "../../../core";
import { E2EIdentifier } from "../../../core/e2e/E2EIdentifier";
import { themeColors } from "../../../ui/_themes/constants/colors";
import { IState } from "../../redux";
import { DisplayMode, View } from "../../../api/api";
import * as helpers from "../../../ui/_themes/helpers";
import { bottomGradient } from "../../../ui/_utils/styleUtils";

export const PaytableMobile = () => {
  const { language } = useStaticContext();

  const paytableContent = useSelector(
    (state: IState) => state.paytable.content
  );

  const view = useSelector((state: IState) => state.view);
  const displayMode = useSelector((state: IState) => state.displayMode);

  const paytableActive =
    displayMode === DisplayMode.DEFAULT && view === View.PAYTABLE;

  const { PaytableTitle: paytableTitle } = language;

  if (!paytableActive) {
    return null;
  }

  return (
    <PaytableWrapperMobile
      paytableContent={paytableContent}
      paytableTitle={paytableTitle}
    />
  );
};

const PaytableMobileView = ({ className, paytableContent, paytableTitle }) => {
  return (
    <div className={className} data-e2e-id={E2EIdentifier.PAYTABLE_VIEW}>
      <div>
        <div>
          <h1>{paytableTitle}</h1>
          {paytableContent && (
            <section>
              <div dangerouslySetInnerHTML={{ __html: paytableContent }} />
            </section>
          )}
        </div>
      </div>
    </div>
  );
};

const PaytableWrapperMobile = styled(PaytableMobileView)`
  pointer-events: all;
  overflow-y: hidden;

  height: 100%;
  width: 100%;

  background-color: ${helpers.getBackgroundColor("settingsWindow")};

  > div {
    position: relative;

    max-height: 100%;
    width: 100%;

    overflow-y: auto;
  }

  > div > div {
    background: ${helpers.getBackgroundColor(
      "settingsWindowContent",
      "settingsWindow.content"
    )};
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    flex-basis: 100%;
    flex-shrink: 0;

    /* overflow-y: scroll; */

    color: ${themeColors.onPrimary};
    text-align: left;

    ${bottomGradient};

    &:after {
      position: sticky;
    }
  }

  > div > div > section {
    margin-top: 1em;
  }

  @media (min-width: 640px) {
    > div > div > section {
      margin-top: 0;
    }
  }

  > div > div > h1 {
    font-size: 1.3em;
    padding: 0;
    text-align: center;
    text-transform: uppercase;
    font-weight: 700;
    letter-spacing: 0.03em;
    margin: 0 0 0.4em 0;
  }
`;
